var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.length > 0)?_c('div',[_vm._l((_vm.value),function(schedule,i__){return [_c('Schedule',{key:i__,attrs:{"value":schedule,"index":i__},on:{"view":function($event){return _vm.$emit('view', schedule)},"edit":function($event){return _vm.$emit('edit', schedule)}}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }